export const content = {
  navItems: [
    { id: 1, title: "home", link: "#home" },
    { id: 1, title: "about", link: "#about" },
    { id: 1, title: "Tokenomics", link: "#tokenomics" },
    { id: 1, title: "How to buy", link: "#HowToBuySection" },
  ],
};
